import { Avatar, AvatarContent, AvatarDescription, AvatarImage, AvatarTitle } from '@playbooks/ui/components/avatar';
import { Link } from '@playbooks/ui/components/link';

export const HeroAvatar = ({ thumbnail, title, text, href, target = undefined }) => (
	<Link variant='ghost' href={href} target={target} className='group flex-between-top gap-3 h-auto p-0'>
		<Avatar className='flex-start gap-4'>
			<AvatarImage size='md' src={thumbnail} alt={title} />
			<AvatarContent>
				<AvatarTitle className='text-sm'>{title}</AvatarTitle>
				<AvatarDescription className='group-hover:underline opacity-80'>{text}</AvatarDescription>
			</AvatarContent>
		</Avatar>
	</Link>
);
